export default __webpack_public_path__ + "static/media/manifestations_boris-johson_girl.9cbc93f7.jpg";